export const BREAKPOINT = `only screen and (max-width: 768px)`;
export const verticalMargin = 30;
export const horizontalMargin = 0;
export const LOGO_HEIGHT = 60;
export const LOGO_HEIGHT_DESKTOP = 80;
export const THUMBNAIL_SPACE = 12;
export const EXPAND_DISTANCE = 30;
